// @flow

// !!! IMPORTANT !!!
//
// This file is shared between the zapier/zapier and zapier/next-js repository.
// Any changes made here should be reflected in there as well.
// For more information, see: https://zapier.quip.com/xaKqAOpdhpY2#ZXFACA8Jnp9
import React from 'react';
import bemify from 'bemify-js';

import Img from 'web-ssr/app/common/components/Img';
import { buildStaticAssetPath } from 'web-ssr/app/common/next/utils';

const bem = bemify('loading-star');

type LoadingStarProps = { className?: string };

const LoadingStar = (props: LoadingStarProps) => {
  const { className } = props;

  return (
    <Img
      alt="Loading spinner"
      className={bem(className)}
      src={buildStaticAssetPath('images/loading_56x56.gif')}
    />
  );
};

export default LoadingStar;
